export default "__VITE_ASSET__CGl8059q__"